import StorageService from "@/services/storage.service";
import gettext from "@/language";
import Router from "@/router";
import ApiService from "@/services/api/api.service";
import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useGeneralStore = defineStore("general", () => {
  const production = process.env.VUE_APP_PRODUCTION == "true";
  const theme = ref(StorageService.get("olaii_theme") || "light");
  const sidebarOpen = ref(false);
  const sidebarSmall = ref(StorageService.get("olaii_sidebar_small") == "true");
  const sideViewWidth = ref(null);
  const sidebarSmallCookieKey = "olaii_sidebar_small";
  const languageCookieKey = "olaii_guestlist_language";
  const languages = gettext.available;
  const language = ref(StorageService.get(languageCookieKey) || gettext.current);
  const organization = ref(null);
  const event = ref(null);
  const organizations = ref([]);
  const organizationId = computed(() => (organization.value ? organization.value.id : null));
  const eventId = computed(() => (event.value ? event.value.id : null));
  const permissions = computed(() => (organization.value ? organization.value.permissions : {}));
  const viewHeader = computed(() => (event.value ? event.value.name + " - " : "") + (organization.value ? organization.value.name : ""));
  const modules = computed(() => ({
    PLUS_ONES: organization.value ? !!organization.value.modules.find((m) => m == "PLUS_ONES") : undefined,
    PARTNERS: organization.value ? !!organization.value.modules.find((m) => m == "PARTNERS") : undefined,
    TICKETING_INTEGRATION: organization.value ? !!organization.value.modules.find((m) => m == "TICKETING_INTEGRATION") : undefined,
    SEND_TICKETS_TO_GUESTS: organization.value ? !!organization.value.modules.find((m) => m == "SEND_TICKETS_TO_GUESTS") : undefined,
  }));

  async function getOrganization(newOrganizationId) {
    if (newOrganizationId == organizationId.value) return organization;
    if (newOrganizationId) {
      StorageService.setOrganization(newOrganizationId);
    } else {
      newOrganizationId = StorageService.getOrganization();
    }
    const response = await ApiService.organizations.get(newOrganizationId);
    return setOrganization(response);
  }

  async function getEvent(newOrganizationId, newEventId) {
    if (newEventId == eventId.value) return event;
    if (newEventId) {
      StorageService.setEvent(newEventId);
    } else {
      newEventId = StorageService.getEvent();
    }
    const response = await ApiService.events.get(newOrganizationId, newEventId);
    return setEvent(response);
  }

  async function getData() {
    if (!organizationId.value) return;
    // Fetch stuff
  }

  async function getOrganizations(query) {
    organizations.value = await ApiService.organizations.getAll(query);
    return organizations;
  }

  function cleanStore() {
    organizations.value = [];
  }

  function setOrganization(data) {
    // console.log("[GENERAL STORE] Organization", data);
    organization.value = data;
    if (!data) StorageService.removeOrganization();
    return organization;
  }

  function setEvent(data) {
    // console.log("[GENERAL STORE] Event", data);
    event.value = data;
    if (!data) StorageService.removeEvent();
    return event;
  }

  function changeSideViewWidth(data) {
    sideViewWidth.value = data;
  }

  function setSidebarOpen(isOpen) {
    sidebarOpen.value = isOpen;
  }

  function toggleSidebar() {
    sidebarOpen.value = !sidebarOpen.value;
  }

  function setSidebarSmall(isSmall) {
    sidebarSmall.value = isSmall;
    StorageService.save(sidebarSmallCookieKey, isSmall);
  }

  function toggleSidebarSmall() {
    sidebarSmall.value = !sidebarSmall.value;
    StorageService.save(sidebarSmallCookieKey, sidebarSmall.value);
  }

  function toggleTheme() {
    const newTheme = theme.value == "light" ? "dark" : "light";
    setTheme(newTheme);
  }

  function setTheme(newTheme) {
    theme.value = newTheme;
    document.body.classList.remove("dark");
    document.body.classList.remove("light");
    document.body.classList.add(newTheme);
    StorageService.save("olaii_theme", newTheme);
  }
  setTheme(theme.value);

  function setLanguage(newLanguage) {
    if (newLanguage == language.value) return;
    language.value = newLanguage;
    gettext.current == newLanguage;
    StorageService.save(languageCookieKey, newLanguage);
    Router.go(Router.currentRoute);
  }

  return {
    production,
    cleanStore,
    getData,

    theme,
    toggleTheme,
    setTheme,

    sidebarOpen,
    sidebarSmall,
    sidebarSmallCookieKey,
    setSidebarOpen,
    toggleSidebar,
    setSidebarSmall,
    toggleSidebarSmall,
    changeSideViewWidth,

    languages,
    language,
    setLanguage,

    organization,
    organizations,
    organizationId,
    setOrganization,
    getOrganization,
    getOrganizations,
    permissions,
    modules,
    viewHeader,

    event,
    eventId,
    getEvent,
    setEvent,
  };
});
